<template>
  <div class="box">
    <div class="product" id="product">
      <header>
        <div>
          <img src="../assets/logo.png" alt="" />
          <span class="logoname">KOPERASI SIMPAN PINJAM DANA CEPAT CAIR</span>
        </div>
        <nav>
          <a href="#product">Beranda</a>
          <a href="#about">Tentang kami</a>
          <a href="#partner">Jangkauan Layanan</a>
        </nav>
      </header>
      <div class="name">KOPERASI SIMPAN PINJAM DANA CEPAT CAIR</div>
      <div class="logomsg">
        KOPERASI SIMPAN PINJAM DANA CEPAT CAIR adalah koperasi keuangan yang dinamis dan inovatif yang menjadi cahaya harapan pemberdayaan keuangan bagi individu maupun bisnis. Dengan komitmen untuk menyediakan solusi keuangan yang cepat dan mudah diakses.
      </div>
      <!-- <a href="https://play.google.com/store/apps/details?id=com.bantu.cepat" class="googlelogo"></a> -->
    </div>
    <div class="about" id="about">
      <div class="title">Tentang kami<span></span></div>
      <div class="content">
        KOPERASI SIMPAN PINJAM DANA CEPAT CAIR, kami memahami kebutuhan keuangan yang beragam dan terus berkembang dari para anggota kami. Nama kami, yang berarti "Koperasi Simpan Pinjam Dana Cair Cepat" mencerminkan tujuan utama kami untuk memastikan akses cepat ke dana saat dibutuhkan yang paling. Sebagai sebuah organisasi yang berfokus pada pengguna, kami berkomitmen untuk mengembangkan ketahanan keuangan, sehingga pengguna dapat mencapai tujuan mereka
      </div>
    </div>
    <div class="partner" id="partner">
      <h2 class="title">Keuntungan kami<span></span></h2>
      <div class="content">
        <div class="img-text">
          <img src="../assets/about-1.png" alt="">
          <div class="text-box">
            <div class="text-title">Efisiensi</div>
            <p>Kami bangga dengan proses pinjaman yang efisien dan pencairan dana yang cepat. Kami mengerti bahwa situasi darurat dan peluang tidak menunggu siapa pun, dan proses kami yang efisien mencerminkan komitmen kami untuk memberikan dukungan keuangan tepat waktu.</p>
          </div>
        </div>
        <div class="img-text">
          <div class="text-box">
            <div class="text-title">Inovasi</div>
            <p>Kami merangkul kemajuan teknologi untuk memastikan anggota kami mengalami pengalaman yang lancar dan nyaman. Melalui platform online dan aplikasi seluler, anggota dapat mengelola akun mereka, mengajukan pinjaman dengan mudah.</p>
          </div>
          <img src="../assets/about-2.png" alt="">
        </div>
      </div>
    </div>
    <div class="services">
      <h2 class="title">Jangkauan Layanan<span></span></h2>
      <div class="services-box">
        <div class="services-item">
          <img src="../assets/iocn-1.png" alt="">
          <div class="item-text">
            <div>Pinjaman Cepat</div>
            <p>Kami menawarkan berbagai jenis pinjaman kepada anggota kami, mulai dari dana darurat pribadi hingga modal ekspansi bisnis, memenuhi beragam kebutuhan keuangan dalam situasi yang berbeda.</p>
          </div>
        </div>
        <div class="services-item">
          <img src="../assets/iocn-2.png" alt="">
          <div class="item-text">
            <div>Rencana Tabungan</div>
            <p>Rencana tabungan kami dirancang untuk membantu anggota dalam membentuk kebiasaan menabung yang sehat, memberikan dukungan keuangan untuk tujuan masa depan dan kejadian tak terduga.</p>
          </div>
        </div>
        <div class="services-item">
          <img src="../assets/iocn-3.png" alt="">
          <div class="item-text">
            <div>Penasihat Investasi</div>
            <p>Tim profesional kami memberikan nasihat tentang manajemen portofolio investasi, manajemen risiko, dan perencanaan keuangan kepada anggota, membantu mereka dalam membuat keputusan keuangan yang terinformasi.</p>
          </div>
        </div>
        <div class="services-item">
          <img src="../assets/iocn-4.png" alt="">
          <div class="item-text">
            <div>Layanan Daring</div>
            <p>Melalui aplikasi seluler kami, anggota dapat mengakses informasi akun, dan mengajukan pinjaman kapan saja, di mana saja, memastikan pengalaman layanan keuangan yang nyaman dan lancar.</p>
          </div>
        </div>
      </div>
      <!-- <div class="img"></div>
      <div class="img2"></div> -->
    </div>

    <div class="apakah">
      <h2 class="title">Apakah saya memenuhi syarat?<span></span></h2>
      <div class="apakah-text">

        <p> 1. Unduh aplikasi kami</p>
        <p>2. Daftarkan dan kirimkan informasi aplikasi</p>
        <p> 3. Unggah dokumen persetujuan yang diperlukan</p>
        <p> 4. Tunggu hasil persetujuan, jika persetujuan lolos maka Anda akan mendapatkan kualifikasi dan besaran pinjaman</p>

      </div>
    </div>
    <footer class="bottom">
      <p>
        Email: kspinjamdanacepatcair@hotmail.com
        <br>
        Alamat: Jalan Kapten Pierre Tendean LT5 No.27A Kuningan Barat Mampang Prapatan Kota Adm. Jakarta Selatan DKI Jakarta
      </p>
      <div class="capyle">© 2023 KOPERASI SIMPAN PINJAM DANA CEPAT CAIR</div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  data() {
    return {
      isMore: false,
      menuIndex: 0,
      screenWidth: document.body.clientWidth,
      showMenu: false,
      showPrivasi: false,
      show: false,
    };
  },
  mounted() {
    if (this.$route.query.go == 1) {
      this.$nextTick(() => {
        setTimeout(() => {
          document.getElementById("partner").scrollIntoView();
        }, 100);
      });
    }
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
  },
  methods: {
    choiceMenu(index) {
      this.menuIndex = index;
      setTimeout(() => {
        this.showMenu = false;
      }, 100);
      switch (index) {
        case 0:
          document.getElementById("home").scrollIntoView();
          break;
        case 1:
          document.getElementById("step").scrollIntoView();
          break;
        case 2:
          document.getElementById("product").scrollIntoView();
          break;
        case 3:
          document.getElementById("user").scrollIntoView();
          break;
        case 4:
          document.getElementById("about").scrollIntoView();
          break;
        case 5:
          document.getElementById("privacy").scrollIntoView();
          break;
        case 6:
          document.getElementById("footer").scrollIntoView();
          break;
        default:
          break;
      }
    },
    menuClick() {
      this.showMenu = !this.showMenu;
    },
    toPrivacy() {
      this.$router.push({ path: "/privacy" });
    },
  },
};
</script>
<style lang="less">
@import url("@/style/m_index.less") only screen and (max-width: 750px);
@import url("@/style/pc_index.less") only screen and (min-width: 750px);
</style>
<style scoped>
.privasi {
  margin-top: 234px;
  padding: 0;
}
</style>
